/**
 * @file 普通落地页
 * @author chenyuyang
 */
// @ts-nocheck
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {fetchV1Search, getAssessmentStatic} from '../../actions/searchAction';
import {message, Spin} from 'antd';
import CustomButton from '../../components/CustomButton/index';
import Report from './cardTypeComp/Report';
import Location from './cardTypeComp/Location';
import Custom from './cardTypeComp/Custom';
import NoNumCustom from './cardTypeComp/NoNumCustom';
import EmptyComp from './EmptyComp';
import {recordProxy, getUrlValue, bCat_2055_request} from '../../util';
import {moreServiceList} from './constans';

import iconDianHuaBang from '../../asset/img/search/dianHuaBang.jpeg';
import imgBanner from './imgs/banner.png';

import './style.less';
const Message = message;
export class NormalLandPage extends React.Component<any, any> {
    constructor(prop: any) {
        super(prop);
        const search = decodeURIComponent(getUrlValue('search'));
        const word = decodeURIComponent(getUrlValue('word'));
        const srcId = decodeURIComponent(getUrlValue('srcid'));
        const alaType = decodeURIComponent(getUrlValue('datatype'));
        const tag = getUrlValue('tag') ? decodeURIComponent(getUrlValue('tag')) : '';
        this.state = {
            search,
            searchData: null,
            alaType,
            dataType: '',
            phoneType: '',
            word,
            title: '',
            isZhuKa: srcId === '26310',
            srcid: srcId,
            tag, // tag由阿拉丁卡片传过来
            dianhuanbangInfo: {},
            spinning: true,
            isEmpty: false,
            titleSimilar: ''
        };
    }
    componentDidMount() {
        const {search, word, alaType} = this.state;
        this.getSearchInfo(search, word, alaType);
    }

    getSearchInfo = (search, word, alaType) => {
        const {fetchV1Search} = this.props;
        this.setState({
            spinning: true
        });
        const fetchParam = {
            page: 1,
            size: 10,
            search: search,
            user_search: word || ''
        };
        if (alaType === '1' || alaType === '2') {
            fetchParam.datatype = alaType;
        }
        const fetchSearch = (params) => fetchV1Search({
            ...params,
            ...fetchParam
        }).then(res => {
            const {code, data, message} = res || {};
            if (code === 200 && alaType !== '1' && alaType !== '2') {
                // 正常有号码的客服页面
                const {
                    temp, dataType, phoneType, phoneList, title, dianhuanbangInfo
                } = this.formatData(data);
                recordProxy('phone-search-page', title, JSON.stringify({dataType}));

                this.setState({
                    temp,
                    dataType,
                    phoneType,
                    phoneList,
                    title,
                    dianhuanbangInfo,
                    isEmpty: Object.keys(data).length === 0
                });
            } else if (code === 200 && (alaType === '1' || alaType === '2')) {
                // 无号码的客服页面
                const key = Object.keys(data)[0];
                const dataType = 'noNumCustom';
                let temp = '';
                let isEmpty = alaType === '2';
                let titleSimilar = '';

                if (data[key] && alaType === '1') {
                    temp = <NoNumCustom data={data[key]}/>;
                } else if (data[key] && alaType === '2') {
                    titleSimilar = data[key]['customer'][0].title_similar;
                } else {
                    isEmpty = true;
                }
                recordProxy('phone-search-page', 'enter', JSON.stringify({dataType, search}));
                this.setState({
                    temp,
                    dataType,
                    isEmpty,
                    titleSimilar
                });
            } else {
                Message.error(message);
            }
            this.setState({
                spinning: false
            });
        }). catch(err => {
            // Message.error(err);
            this.setState({
                spinning: false
            });
        });
        bCat_2055_request(fetchSearch);
    };

    formatData = (data) => {
        if (!data) return;
        const {userInfo = {}} = this.props;
        const {search, word, isZhuKa, alaType, srcid} = this.state;
        const key = Object.keys(data)[0];
        let temp: any = '';
        let dataType = '';
        let pageLogType = '';
        let phoneType = '';
        let phoneList = [];
        let title = '';
        let dianhuanbangInfo: any = {};
        if (data[key]?.reports) {
            dataType = 'reports';
            pageLogType = 'reports';
            phoneType = 'op';
            phoneList = [{phone: search}];
            if (srcid === '52533') {
                pageLogType = 'reportsFraud';
            }
            temp = <Report search={search} data={data[key]} />;
        } else if (data[key]?.poi || data[key]?.customer) {
            if (data[key]?.poi) {
                phoneType = 'cp';
                pageLogType = 'poi';
                phoneList = data[key]?.poi[0].phone.map(item => {
                    return {
                        phone: item.number
                    };
                });
                title = data[key]?.poi[0].title;
                dianhuanbangInfo = {
                    name: data[key]?.poi[0].source_name,
                    url: data[key]?.poi[0].source_jump_url
                };
            } else {
                phoneType = 'op';
                pageLogType = 'customer';
                phoneList = data[key]?.customer[0].phone_list;
                title = data[key]?.customer[0].title;
                dianhuanbangInfo = {
                    name: data[key]?.customer[0].source_name,
                    url: data[key]?.customer[0].source_jump_url
                };
            }
            dataType = 'custom';
            const isDianHuaBang = dianhuanbangInfo.name && dianhuanbangInfo.url;
            temp = <Custom
                isZhuKa={isZhuKa}
                secmRecord={this.secmRecord}
                login={userInfo.code === 200}
                search={search} data={data[key]}
                isDianHuaBang={isDianHuaBang}
            />;
        } else {
            phoneList = [{phone: search}];
            dataType = 'location';
            pageLogType = 'location';
            temp = <Location search={search} data={data[key]} />;
        }
        return {
            temp,
            dataType,
            phoneType,
            pageLogType,
            phoneList,
            title: title || search || word,
            dianhuanbangInfo
        };
    };
    login = () => {
        const isDev = window.location.href.indexOf('haoma.baidu.com') > -1 ? false : true;
        const ele = document.createElement('a');
        ele.href = `https://passport${isDev ? '.qatest' : ''}.baidu.com/v2/?login&u=${
            encodeURIComponent(window.location.href)
        }`;
        ele.click();
    };
    secmRecord = (type) => {
        const {title, alaType} = this.state;
        const param = {
            btnType: type,
            dataType: alaType
        };
        recordProxy('phoneSearch', title, JSON.stringify(param));
    };
    jump = (type, jumpType?) => {
        this.secmRecord(type + (jumpType ? '-' + jumpType : ''));
        const {userInfo = {}} = this.props;
        const {phoneType, phoneList, alaType, search, dataType} = this.state;
        let routerPath = '';
        switch (type) {
            case 'attest':
                routerPath = '/attest';
                break;
            case 'appeal':
                if (userInfo.code === 200) {
                    // routerPath = '/appeal/step/1?type=' + phoneType + '&phones='
                    //     + encodeURIComponent(JSON.stringify(phoneList));
                    routerPath = '/appeal?phones=' + encodeURIComponent(JSON.stringify(phoneList));
                } else {
                    this.login();
                    return;
                }
                break;
            case 'occupy':
                if (userInfo.code === 200) {
                    routerPath = '/occupy?phones=' + encodeURIComponent(JSON.stringify(phoneList));
                } else {
                    this.login();
                    return;
                }
                break;
            case 'mark':
                routerPath = `/mark?pagef=phonesearch-${dataType}&phones=`
                    + encodeURIComponent(JSON.stringify(phoneList));
                break;
            case 'feedback':
                if (userInfo.code === 200) {
                    routerPath = '/feedback?phones=' + encodeURIComponent(JSON.stringify(phoneList))
                        + '&pagef=phonesearch';
                } else {
                    this.login();
                    return;
                }
                break;
            case 'noNumFeedback':
                if (userInfo.code === 200) {
                    routerPath = `/feedback?datatype=${alaType}&search=${search}&pagef=phonesearch`;
                } else {
                    this.login();
                    return;
                }
                break;
            case 'noNumMark':
                routerPath = '/mark?pagef=noNumCustom';
                break;
            case 'home':
                routerPath = '/home';
                break;
            default:
        }
        routerPath && this.props.history.push(routerPath);
    };

    jumpAlias = (url) => {
        if (url) {
            const dom = document.createElement('a');
            dom.href = url;
            dom.setAttribute('target', '_bank');
            dom.click();
        }
    };

    render() {
        const {dataType, temp, dianhuanbangInfo = {}, spinning, isEmpty, tag, titleSimilar} = this.state;
        const isDianHuaBang = dianhuanbangInfo.name && dianhuanbangInfo.url;
        return (
            <div className="page-normal-land-page">
                <Spin
                    delay={150}
                    spinning={spinning}
                >
                    <div className="banner-wrapper" onClick={() => this.jump('attest')}>
                        <img src={imgBanner} className="banner"></img>
                        <div className="content">
                            <p className="title">企业号码认证</p>
                            <p className="tip">官方标识更权威，用户更信任</p>
                            <div className="banner-btn-wrap">
                                <CustomButton
                                    type="default"
                                    className="banner-btn"
                                >
                                    去了解更多
                                </CustomButton>
                                <span className="btn-tip">仅企业用户可认证</span>
                            </div>
                        </div>
                        {/* <div className="bottom-bg"></div> */}
                    </div>
                    {isEmpty
                        ? <EmptyComp dataType={dataType} titleSimilar={titleSimilar} jump={this.jump} />
                        : <React.Fragment>
                            <div className="info-container">
                                {temp}
                            </div>
                            <div className="more-service">
                                <p className="title">更多服务</p>
                                <div className="service-list">
                                    {moreServiceList.map(item => {
                                        if (item.auth.includes(dataType)) {
                                            return <CustomButton
                                                key={item.type}
                                                className="service-btn"
                                                type="default"
                                                onClick={() => this.jump(item.type, 'btn')}
                                            >
                                                {item.text}
                                            </CustomButton>;
                                        }
                                    })}
                                </div>
                            </div>
                            {isDianHuaBang && <div className="dianhuabang">
                                <div className="source-key">*该第三方数据来源为</div>
                                <div className="source-value" onClick={() => this.jumpAlias(dianhuanbangInfo.url)}>
                                    <img src={iconDianHuaBang} className="logo"></img>
                                    <div className="text">{dianhuanbangInfo.name}</div>
                                </div>
                            </div>}
                        </React.Fragment>}
                </Spin>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch: Function) {
    return {
        fetchV1Search: (obj: any) => fetchV1Search(dispatch, obj),
        getAssessmentStatic: (obj: any) => getAssessmentStatic(dispatch, obj)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NormalLandPage));
